module.exports = __webpack_public_path__ + "img/Software.bacd5e8a.png";